import React from "react";
import styled from '@emotion/styled';


const DivColumn = styled.div(({gap}) => ({
  display: "flex", 
  flexDirection: "column" ,
  gap: gap || 0,
}));

export default function ContainerColumn({ children, gap, ...props }) {

    return (
      <DivColumn gap={gap} {...props}>
        {children}
      </DivColumn>
    );
  }